import { SxProps } from '@mui/material';

export const label: SxProps = {
  mt: 2,
  mb: 1,
};

export const container: SxProps = {
  height: '100%',
  display: 'flex',
  alignItems: 'center',
};

export const drawerPaper = (height?: string): SxProps => {
  return {
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    height,
    background: '#2C2C2C',
    color: '#ffffff',
    overflow: 'hidden',
  };
};
